export default "__VITE_ASSET__BmWLqLHx__"